<template>
  <div class="book-mall-page">
    <!-- 搜索框 -->
    <div class="search-wrapper">
      <div class="search-input-box" @click="goBookSearch">
        <img class="search-icon" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/boolMall/search.png"
          alt="搜索" />
        <input class="search-placeholder" type="text" readonly placeholder="请输入图书名称" />
      </div>
    </div>

    <!-- 悬浮广告气泡：样式仿 arkHome/chat.vue 的 yuanqiu（fixed 右侧悬浮 + 可拖拽 + 可关闭），功能仍为广告位点击跳转 -->
    <div v-if="bookMallTopAdImage && bookMallTopAdShow" ref="bookMallTopAd" class="book-mall-top-ad"
      :class="{ 'book-mall-top-ad-animate': topAdAnimating }" :style="topAdPosStyle" @touchstart="onAdTouchStart"
      @touchmove="onAdTouchMove" @touchend="onAdTouchEnd" @click="goBookMallTopAd">
      <img :src="bookMallTopAdImage" alt="" />
      <div class="book-mall-top-ad-close" @click.stop="closeBookMallTopAd">
        <img src="@/assets/img/loginImg/close.png" alt="" />
      </div>
    </div>

    <!-- <div class="book-mall-live-card">
      <div class="book-mall-live-info">
        <div class="book-mall-live-avatar">
          <img
            src="https://lanhu-oss-2537-2.lanhuapp.com/SketchPnga2e8eafb1ddf0eabb789c51ee71078c71a56ee1ab26cefbe66189972bcf76826"
            alt=""
          />
        </div>
        <div class="book-mall-live-content">
          <div class="book-mall-live-title">直播名称直播名称直播名称直播名称…</div>
          <div class="book-mall-live-summary">
            <span class="book-mall-live-status">直播中</span>
            <span class="book-mall-live-description">AI数字人直播&nbsp;·&nbsp;限时秒杀进行中</span>
          </div>
        </div>
      </div>
      <img
        class="book-mall-live-play"
        src="https://lanhu-oss-2537-2.lanhuapp.com/SketchPng332036491c6417e2eae881071906d9dace6cf8080d3a882ed3d682eb5be4c7fa"
        alt=""
      />
    </div> -->

    <!-- 轮播广告位 -->
    <div class="book-mall-banner">
      <BannerVant />
    </div>

    <!-- 功能模块区：直播中左侧显示直播小窗；无直播时小窗隐藏、两个广告位横排一行。展示图固定，是否展示与跳转由 h5002 广告位下发 -->
    <div class="function-modules" :class="{
      'function-modules-no-live': !liveBoxVisible,
      'function-modules-empty': functionModulesEmpty,
    }">
      <!-- preview 确认有直播（返回地址）才展示，避免无直播时闪一下 -->
      <div v-show="liveBoxVisible" class="function-modules-left">
        <div class="function-modules-left-shadow" @click="goLiveRoom"></div>
        <!-- 微信 iOS 拦截无手势自动播放：点角标以手势就地起播（不跳转、不校验登录） -->
        <div v-if="livePlayState === 'paused'" class="live-video-play-hint" @click.stop="playLiveVideo">
          <img src="@/assets/img/live/start.png" alt="点击播放" />
        </div>
        <div class="function-modules-title-box">
          <img src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-words-mini/live.gif" alt="">
          <div>{{ liveTitle }}</div>
        </div>
        <div class="function-modules-title-sub">
          <div>{{ liveSubTitle }}</div>
        </div>
        <video ref="liveVideo" class="live-video" autoplay muted playsinline webkit-playsinline x5-playsinline
          x5-video-player-type="h5" @playing="livePlayState = 'playing'" @pause="onLiveVideoPause"></video>
      </div>
      <div class="function-modules-right">
        <div v-if="functionModuleWelfareAd" class="new-user-welfare"
          :style="functionModuleBgStyle(functionModuleWelfareAd)" @click="goWelfare"></div>
        <div v-if="functionModuleSeckillAd" class="seckill-course"
          :style="functionModuleBgStyle(functionModuleSeckillAd)" @click="goSeckill"></div>
      </div>
    </div>

    <!-- 热卖推荐 -->
    <div class="hot-sale-section" v-if="hotSaleList.length">
      <div class="hot-sale-header">
        <span class="section-title">热卖推荐</span>
        <div class="hot-tags">
          <div class="hot-tag-item">
            <img class="hot-icon" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/boolMall/hot.png" alt="热" />
          </div>
        </div>
      </div>

      <div class="hot-book-list">
        <div class="book-item" v-for="(item, index) in hotSaleList" :key="item.packageId || item.productId || index"
          @click="goHotSaleDetail(item)">
          <div class="book-cover">
            <img :src="hotSaleCover(item)" alt="" />
            <span v-if="item.originalPrice" class="origin-text">¥{{ item.originalPrice }}</span>
          </div>
          <div class="book-price">
            <span class="courseType"
              v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount">拼团价</span>
            <span v-else-if="item.promotionLabel" class="courseType">{{
              item.promotionLabel === 1 ? '折后价' : item.promotionLabel === 4 ? '券后价' : '限时价'
            }}</span>
            <span class="courseType" v-else>免费</span>
            <p class="showPic">
              <template v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount">
                <b>¥</b>
                <span>{{ item.productDiscountRespVO.discountMinPrice }}</span>
              </template>
              <template v-else>
                <b>¥</b>
                <span :class="{ fontSty: item.sellPrice === 0 && !item.promotionLabel }">{{
                  item.sellPrice
                }}</span>
              </template>
            </p>
          </div>
          <div class="bookName">{{ (item.productBookInfoVO && item.productBookInfoVO.bookName) || item.name }}</div>
        </div>
      </div>
    </div>

    <!-- 分类筛选 -->
    <div class="category-filter">
      <div class="filter-item" @click="openFilterModal">
        <span class="filter-text" :class="{ 'filter-text-active': filterState.examTypeIdList.length }">考试类型</span>
        <img class="filter-arrow" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/boolMall/down.png" />
      </div>
      <div class="filter-item" @click="openFilterModal">
        <span class="filter-text" :class="{ 'filter-text-active': filterState.subjectIdList.length }">科目</span>
        <img class="filter-arrow" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/boolMall/down.png" />
      </div>
      <div class="filter-item" @click="openFilterModal">
        <span class="filter-text" :class="{ 'filter-text-active': filterState.bookTypeIdList.length }">图书分类</span>
        <img class="filter-arrow" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/boolMall/down.png" />
      </div>
    </div>

    <!-- 图书卡片列表 -->
    <div class="book-card-list">
      <template v-if="bookList.length">
        <BookCard v-for="(item, k) in bookList" :key="k" :item="item" @click="goBookDetail" />
        <p v-if="bookMallLoadingMore" class="book-card-list-end">加载中...</p>
        <p v-else-if="bookMallListLoaded && !hasMoreBookMall" class="book-card-list-end">
          没有更多课程了！
        </p>
      </template>
      <EmptyData v-else-if="bookMallListLoaded" :emptyName="'noProductList'" />
    </div>

    <FilterModal v-if="showFilterModal" :initial-filter="filterState" @close="closeFilterModal"
      @confirm="onFilterConfirm" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';
import EmptyData from '@/components/emptyData/emptyData.vue';
import { reqBookMallList, reqLiveBroadcastPreview } from '@/api/bookMall';
import {
  resetProductData, resetCoursePackage, handleJumpType, gioPlatform, isminiLogin,
  judgmentPlatform, isAppVersionAbove,
} from '@/utils/tools';
import {
  reqTypeList, reqProductsNew, reqMajorAd, reqAdvertPlaying,
} from '@/api/home';
import { reqCombinationlist } from '@/api/combination';
import {
  BOOK_MALL_HOT_SALE_RECOMMEND_ID,
  BOOK_MALL_HOME_RECOMMEND_ID,
  BOOK_MALL_FUNCTION_MODULES_AD_CODE,
  BOOK_MALL_NEW_USER_WELFARE_AD_CONTENT_ID,
  BOOK_MALL_SECKILL_COURSE_AD_CONTENT_ID,
  BOOK_MALL_TOP_AD_CODE,
} from './constants/bookMallFilterOptions';
import FilterModal from './components/FilterModal.vue';
import BannerVant from './components/Banner.vue';
import BookCard from './components/BookCard.vue';

export default {
  name: 'BookMallPage',
  components: {
    BookCard, // 注册
    BannerVant,
    FilterModal,
    EmptyData,
  },
  data() {
    return {
      bookList: [],
      hotSaleList: [],
      /** 热卖推荐位 getHotSaleList 返回的 id、标题，用于埋点 adId_var / adName_var */
      hotSaleAdId: '',
      hotSaleAdName: '',
      showFilterModal: false,
      /** 筛选条件（无选中为空数组） */
      filterState: {
        examTypeIdList: [],
        subjectIdList: [],
        bookTypeIdList: [],
      },
      /** h5002 下发、id 为 1017/1018 的广告项，用于跳转 */
      functionModuleWelfareAd: null,
      functionModuleSeckillAd: null,
      /** 胶囊位广告位信息（h5002）用于埋点 adId_var / adName_var */
      functionModulesAdId: '',
      functionModulesAdName: '',
      functionModuleClickAt: null,
      bookMallTopAd: null,
      bookMallTopAdClickAt: null,
      /** 悬浮广告位信息（id、标题）用于埋点 adId_var / adName_var */
      bookMallTopAdId: '',
      bookMallTopAdName: '',
      /** 顶部悬浮广告气泡：显隐与拖拽状态 */
      bookMallTopAdShow: true,
      topAdLeft: null,
      topAdTop: null,
      topAdDrag: null,
      topAdAnimating: false,
      topAdJustDragged: false,
      /** 商城列表请求结束后才展示缺省，避免首屏闪一下 */
      bookMallListLoaded: false,
      /** 商城列表分页参数 */
      bookMallPageNum: 1,
      bookMallPageSize: 20,
      hasMoreBookMall: true,
      bookMallLoading: false,
      bookMallLoadingMore: false,
      /** getBookMall 返回的推荐位 id、标题，用于埋点 adId_var / adName_var */
      bookMallAdId: '',
      bookMallAdName: '',
      /** 首页直播播放状态：loading 拉流中 | playing 播放中 | paused 播放结束 | error 不可用 */
      livePlayState: 'loading',
      /** 小窗显隐：preview 接口确认有直播（返回了地址）才展示，避免无直播时闪一下 */
      liveBoxVisible: false,
      /** 直播标题/副标题，来自基础字段 BOOK_MALL_LIVE（value=标题，remark=副标题），供展示使用 */
      liveTitle: '',
      liveSubTitle: '',
      liveId: '',
    };
  },
  computed: {
    ...mapState(['userInfo']),
    bookMallTopAdImage() {
      const { images } = this.bookMallTopAd || {};
      return Array.isArray(images) ? images[0] : images || '';
    },
    /** 气泡拖拽后改用 left/top 定位，覆盖 CSS 的 right/bottom */
    topAdPosStyle() {
      if (this.topAdLeft === null || this.topAdTop === null) return {};
      return {
        left: `${this.topAdLeft}px`,
        top: `${this.topAdTop}px`,
        right: 'auto',
        bottom: 'auto',
      };
    },
    /** 无直播（error）且无广告位时整块不留空隙 */
    /** 小窗隐藏且无广告位时整块不留空隙（随 liveBoxVisible 走，加载期也不会闪出空隙） */
    functionModulesEmpty() {
      return (
        !this.liveBoxVisible
        && !this.functionModuleWelfareAd
        && !this.functionModuleSeckillAd
      );
    },
  },
  created() {
    if (!this.$root.$data.isApp) return;
    // 尽早接收 App 主动下发的登录态，避免首屏初始化时丢失回调。
    window['iqhApp2jsBridge.triggerSC'] = window['iqhApp2jsBridge.triggerSC'] || {};
    window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
  },
  methods: {
    getLogin(session) {
      if (!this.$root.$data.isApp) return Promise.resolve();
      // iOS / Android 下发 token 字符串，鸿蒙下发 { token }。
      const token = session && typeof session === 'object' ? session.token : session;
      if (token !== undefined) {
        if (typeof token === 'string' && token && !['null', 'undefined', '(null)'].includes(token)) {
          window.localStorage.setItem('accessToken', token);
        } else {
          window.localStorage.removeItem('accessToken');
          return this.$store.dispatch('saveUserInfo', {});
        }
      }
      return this.$root.getUserInfo();
    },
    // 点击直播小窗：纯 H5 引导去小程序/app；App/小程序先校验登录，未登录跳对应登录，已登录进直播间
    goLiveRoom() {
      this.gioEvent('商城直播', '', {
        adId: this.liveId,
        adName: this.liveTitle,
      });
      if (!this.$root.$data.isApp && !this.$root.miniprogram) {
        this.$toast('请前往启航小程序/app观看');
        return;
      }
      // 直播间仅新版 app 支持：版本等于或低于线上版本（iOS 6.1.3 / 安卓 6.1.1 / 鸿蒙 1.2.1）均提示更新
      if (this.$root.$data.isApp) {
        const onlineVersions = { ios: '6.1.3', android: '6.1.1', HarmonyOS: '1.2.1' };
        const onlineVersion = onlineVersions[judgmentPlatform()];
        if (onlineVersion && !isAppVersionAbove(onlineVersion)) {
          this.$toast('请更新到最新版本后观看');
          return;
        }
      }
      if (!this.userInfo?.id) {
        if (this.$root.$data.isApp) {
          // App：唤起原生登录，成功后刷新 token 与用户信息，用户再次点击进入
          this.$sendToApp('login', {}, true)
            .then((session) => this.getLogin(session))
            .catch((err) => console.log(err.toString()));
        } else {
          // 小程序：跳小程序登录页，登录后回跳当前页
          isminiLogin(window.location.href);
        }
        return;
      }
      if (this.$root.$data.isApp) {
        this.$sendToApp('jumpToUnauthenticatedLiveRoom', { liveId: this.liveId }, false);
      } else {
        wx.miniProgram.navigateTo({
          url: `/myCourse/liveRoom/liveRoom?liveId=${this.liveId}`,
        });
      }
    },
    // 【自动播放兜底】微信 iOS 等环境拦截无手势的程序化播放：
    // 监听微信 bridge ready 与用户首次触摸（滚动/点击均算），解锁后补播
    // 点击播放角标：以用户手势就地起播（不跳转、不校验登录），'playing' 事件会把状态切回 playing
    playLiveVideo() {
      const video = this.$refs.liveVideo;
      if (!video) return;
      const p = video.play();
      if (p && p.catch) p.catch(() => { });
    },
    // 【自动播放兜底】微信 iOS 等环境拦截无手势的程序化播放：
    // 常驻监听首次触摸（touchstart/touchend/click 三重，滚动、点按均算），解锁后补播；
    // play() 再被拒（如滚动导致手势作废）时，paused 守卫 + 常驻监听保证下一次手势仍会重试
    addLiveGestureUnlock(video) {
      if (this.liveUnlock) return;
      const onGesture = () => {
        if (!video.paused) return;
        const p = video.play();
        if (p && p.catch) p.catch(() => { });
      };
      document.addEventListener('touchstart', onGesture, { passive: true });
      document.addEventListener('touchend', onGesture);
      document.addEventListener('click', onGesture);
      const onBridgeReady = () => {
        this.wxBridgeReady = true;
        onGesture();
      };
      if (this.wxBridgeReady) {
        onGesture();
      } else {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, { once: true });
        this.liveUnlock = { onGesture, onBridgeReady };
        return;
      }
      this.liveUnlock = { onGesture };
    },
    // 微信 bridge ready 后部分版本放行无手势播放；进入页面即注册，避免错过一次性事件
    setupWeixinBridgeUnlock() {
      const onBridgeReady = () => {
        this.wxBridgeReady = true;
        const video = this.$refs.liveVideo;
        if (video && video.paused) {
          const p = video.play();
          if (p && p.catch) p.catch(() => { });
        }
      };
      if (window.WeixinJSBridge) {
        onBridgeReady();
      } else {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, { once: true });
      }
    },
    goBookSearch() {
      this.$router.push({ name: 'searchPage' });
    },
    goBookMallTopAd() {
      if (!this.bookMallTopAd) return;
      // 拖拽松手后的 click 不算点击广告
      if (this.topAdJustDragged) {
        this.topAdJustDragged = false;
        return;
      }
      if (this.bookMallTopAdClickAt && Date.now() - this.bookMallTopAdClickAt < 1000) return;
      this.bookMallTopAdClickAt = Date.now();
      this.gioEvent('商城悬浮广告', '', {
        adId: this.bookMallTopAdId,
        adName: this.bookMallTopAdName,
      });
      handleJumpType(this, this.bookMallTopAd);
    },
    // 悬浮广告气泡拖拽（仿 arkHome/chat.vue 的 yuanqiu）
    onAdTouchStart(event) {
      const e = event.touches[0];
      const rect = this.$refs.bookMallTopAd.getBoundingClientRect();
      this.topAdDrag = {
        offsetX: e.clientX - rect.left,
        offsetY: e.clientY - rect.top,
        htmlWidth: document.documentElement.clientWidth,
        htmlHeight: document.documentElement.clientHeight,
        bWidth: this.$refs.bookMallTopAd.offsetWidth,
        bHeight: this.$refs.bookMallTopAd.offsetHeight,
        originLeft: this.topAdLeft === null ? rect.left : this.topAdLeft,
        originTop: this.topAdTop === null ? rect.top : this.topAdTop,
      };
      // 首次拖拽前把 right/bottom 定位换算成 left/top
      if (this.topAdLeft === null) {
        this.topAdLeft = rect.left;
        this.topAdTop = rect.top;
      }
    },
    onAdTouchMove(event) {
      const drag = this.topAdDrag;
      if (!drag) return;
      if (event.cancelable) event.preventDefault();
      const e = event.touches[0];
      let oLeft = e.clientX - drag.offsetX;
      let oTop = e.clientY - drag.offsetY;
      // 四边越界钳制
      if (oLeft < 0) {
        oLeft = 0;
      } else if (oLeft > drag.htmlWidth - drag.bWidth) {
        oLeft = drag.htmlWidth - drag.bWidth;
      }
      if (oTop < 0) {
        oTop = 0;
      } else if (oTop > drag.htmlHeight - drag.bHeight) {
        oTop = drag.htmlHeight - drag.bHeight;
      }
      // 位移超阈值视为拖拽，松手后的 click 不触发广告跳转
      if (Math.abs(oLeft - drag.originLeft) + Math.abs(oTop - drag.originTop) > 6) {
        this.topAdJustDragged = true;
      }
      this.topAdLeft = oLeft;
      this.topAdTop = oTop;
    },
    onAdTouchEnd() {
      const drag = this.topAdDrag;
      if (!drag) return;
      this.topAdDrag = null;
      // 横向贴边吸附：靠左半屏吸左边缘，靠右半屏吸右边缘
      if (this.topAdLeft < (drag.htmlWidth - drag.bWidth) / 2) {
        this.topAdLeft = 0;
      } else {
        this.topAdLeft = drag.htmlWidth - drag.bWidth;
      }
      this.topAdAnimating = true;
      setTimeout(() => {
        this.topAdAnimating = false;
      }, 400);
    },
    closeBookMallTopAd() {
      this.bookMallTopAdShow = false;
    },
    async getBookMallTopAd() {
      try {
        const res = await reqAdvertPlaying([BOOK_MALL_TOP_AD_CODE]);
        if (res.code !== 0 || !res.data) {
          this.bookMallTopAd = null;
          this.bookMallTopAdId = '';
          this.bookMallTopAdName = '';
          return;
        }
        const topAdPosition = res.data.find((item) => item.adCode === BOOK_MALL_TOP_AD_CODE);
        this.bookMallTopAdId = topAdPosition?.id != null ? String(topAdPosition.id) : '';
        this.bookMallTopAdName = topAdPosition?.title != null ? String(topAdPosition.title) : '';
        this.bookMallTopAd = topAdPosition?.advertisingContentWebInfoRespVOS?.[0] || null;
      } catch (e) {
        this.bookMallTopAd = null;
        this.bookMallTopAdId = '';
        this.bookMallTopAdName = '';
      }
    },
    goWelfare() {
      if (!this.functionModuleWelfareAd) return;
      if (this.functionModuleClickAt && Date.now() - this.functionModuleClickAt < 1000) return;
      this.functionModuleClickAt = Date.now();
      this.gioEvent('商城胶囊位', '', {
        adId: this.functionModulesAdId,
        adName: this.functionModulesAdName,
      });
      handleJumpType(this, this.functionModuleWelfareAd);
    },
    goSeckill() {
      if (!this.functionModuleSeckillAd) return;
      if (this.functionModuleClickAt && Date.now() - this.functionModuleClickAt < 1000) return;
      this.functionModuleClickAt = Date.now();
      this.gioEvent('商城胶囊位', '', {
        adId: this.functionModulesAdId,
        adName: this.functionModulesAdName,
      });
      handleJumpType(this, this.functionModuleSeckillAd);
    },
    async getFunctionModulesAd() {
      const code = BOOK_MALL_FUNCTION_MODULES_AD_CODE;
      try {
        const res = await reqAdvertPlaying([code]);
        const adInfo = res.data?.find((item) => item.adCode === code) || {};
        this.functionModulesAdId = adInfo.id != null ? String(adInfo.id) : '';
        this.functionModulesAdName = adInfo.title != null ? String(adInfo.title) : '';
        const list = adInfo.advertisingContentWebInfoRespVOS || [];
        let welfare = null;
        let seckill = null;
        list.forEach((ad) => {
          const aid = Number(ad.id);
          if (aid === BOOK_MALL_NEW_USER_WELFARE_AD_CONTENT_ID) welfare = ad;
          else if (aid === BOOK_MALL_SECKILL_COURSE_AD_CONTENT_ID) seckill = ad;
        });
        this.functionModuleWelfareAd = welfare;
        this.functionModuleSeckillAd = seckill;
      } catch (e) {
        this.functionModuleWelfareAd = null;
        this.functionModuleSeckillAd = null;
        this.functionModulesAdId = '';
        this.functionModulesAdName = '';
      }
    },
    functionModuleBgStyle(ad) {
      const imageUrl = Array.isArray(ad?.images) ? ad.images[0] : ad?.images;
      if (!imageUrl) return {};
      return {
        backgroundImage: `url(${imageUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '100%',
        backgroundSize: '100% 100%',
      };
    },
    // ===== 直播播放：HTTP-FLV 直播流使用 mpegts.js（flv.js 官方延续版，支持经典 MSE 与 iOS 17.1+ ManagedMediaSource）播放，接口下发两条候选地址依次尝试 =====
    async initLivePlayer() {
      this.livePlayState = 'loading';
      try {
        const urls = await this.getLiveFlvUrls();
        if (!urls.length) {
          // 无直播/接口失败/已到结束时间，小窗保持隐藏
          this.livePlayState = 'error';
          return;
        }
        // 接口确认有直播，展示小窗（先展示再起播，规避 iOS 上 display:none 容器视频被暂停的问题）
        this.liveBoxVisible = true;
        this.liveFlvUrls = urls;
        const mod = await import(/* webpackChunkName: "mpegts" */ 'mpegts.js');
        const mpegts = mod.default || mod;
        if (!mpegts.isSupported()) {
          // 无经典 MSE 且无 ManagedMediaSource（iOS 17.1 以下等），小窗保持隐藏
          this.livePlayState = 'error';
          return;
        }
        this.mpegts = mpegts;
        this.createLivePlayer(0);
      } catch (e) {
        // 拉流信息获取或 mpegts.js 资源加载失败，保持隐藏
        this.livePlayState = 'error';
      }
    },
    // 通过基础字段 BOOK_MALL_LIVE 取直播 ID 与标题，再请求 preview 拿候选 FLV 地址
    async getLiveFlvUrls() {
      try {
        const dictRes = await reqTypeList('BOOK_MALL_LIVE');
        // 直接取第一条；多条由后台启停控制，前端忽略多余项
        const dictItem = (dictRes.data || [])[0];
        if (!dictItem) return [];
        // code=直播id，value=直播标题，remark=副标题
        this.liveTitle = String(dictItem.value || '').trim();
        this.liveSubTitle = String(dictItem.remark || '').trim();
        const liveId = String(dictItem.code || '').trim();
        if (!liveId) return [];
        this.liveId = liveId;
        const res = await reqLiveBroadcastPreview(liveId);
        if (res.code !== 0 || !res.data) return [];
        const { flv, endTime } = res.data;
        // http 链接统一切换为 https，避免 https 页面下被拦截为混合内容
        const urls = (Array.isArray(flv) ? flv : [])
          .filter((url) => /^https?:\/\//i.test(url))
          .map((url) => url.replace(/^http:\/\//i, 'https://'));
        if (!urls.length) return [];
        // endTime 为 GMT+8 时间，到时停止小窗
        const endTs = this.parseGmt8Time(endTime);
        if (endTs && Date.now() >= endTs) return [];
        this.setLiveEndTimer(endTs);
        return urls;
      } catch (e) {
        return [];
      }
    },
    // 'yyyy-MM-dd HH:mm:ss' 按 GMT+8 解析成时间戳，避免客户端时区影响；解析失败返回 null
    parseGmt8Time(str) {
      const m = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/.exec(String(str || ''));
      if (!m) return null;
      return Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4] - 8, +m[5], +m[6]);
    },
    setLiveEndTimer(endTs) {
      this.clearLiveEndTimer();
      if (!endTs) return;
      const delay = endTs - Date.now();
      if (delay <= 0) return;
      // setTimeout 延迟上限 2^31-1 ms，超出部分先截断
      this.liveEndTimer = setTimeout(() => {
        this.liveEndTimer = null;
        this.destroyLivePlayer();
        this.livePlayState = 'paused';
        // 到时停止小窗并隐藏入口
        this.liveBoxVisible = false;
      }, Math.min(delay, 2 ** 31 - 1));
    },
    clearLiveEndTimer() {
      if (this.liveEndTimer) {
        clearTimeout(this.liveEndTimer);
        this.liveEndTimer = null;
      }
    },
    createLivePlayer(urlIndex) {
      this.livePlayState = 'loading';
      this.destroyLivePlayer();
      const { mpegts } = this;
      const video = this.$refs.liveVideo;
      if (!mpegts || !video) return;
      if (urlIndex >= this.liveFlvUrls.length) {
        // 两条候选地址均失败，隐藏小窗
        this.livePlayState = 'error';
        this.liveBoxVisible = false;
        return;
      }
      const player = mpegts.createPlayer({
        type: 'flv',
        isLive: true,
        url: this.liveFlvUrls[urlIndex],
      }, {
        // 直播场景关闭缓冲 stash，降低延迟
        enableWorker: false,
        enableStashBuffer: false,
        stashInitialSize: 128,
        lazyLoad: false,
        autoCleanupSourceBuffer: true,
      });
      this.liveFlvPlayer = player;
      // 静音 + 内联播放，满足移动端自动播放策略；直播仅画面无声音
      video.muted = true;
      video.playsInline = true;
      player.attachMediaElement(video);
      // 【自动播放兜底】微信 iOS 等环境拦截无手势播放，登记手势/bridge 解锁
      // （handler 内有 paused 守卫，常驻无害；不依赖 play() 是否 reject，防止静默挂起漏注册）
      this.addLiveGestureUnlock(video);
      // 当前地址拉流失败时自动切换下一个地址
      player.on(mpegts.Events.ERROR, () => {
        if (this.liveFlvPlayer === player) {
          this.createLivePlayer(urlIndex + 1);
        }
      });
      // 直播起播阶段 play() 常被加载数据打断，数据到位（canplay）时若仍暂停则补一次播放
      this.handleLiveCanPlay = () => {
        if (video.paused) {
          const p = video.play();
          if (p && p.catch) {
            p.catch(() => this.addLiveGestureUnlock(video));
          }
        }
      };
      video.addEventListener('canplay', this.handleLiveCanPlay);
      player.load();
      const playResult = player.play();
      if (playResult && playResult.catch) {
        playResult.catch(() => {
          // 微信 iOS 等环境拦截无手势的自动播放：置为待手势状态（解锁监听已在创建时登记）
          this.livePlayState = 'paused';
        });
      }
    },
    destroyLivePlayer() {
      if (this.liveUnlock) {
        document.removeEventListener('touchstart', this.liveUnlock.onGesture);
        document.removeEventListener('touchend', this.liveUnlock.onGesture);
        document.removeEventListener('click', this.liveUnlock.onGesture);
        if (this.liveUnlock.onBridgeReady) {
          document.removeEventListener('WeixinJSBridgeReady', this.liveUnlock.onBridgeReady);
        }
        this.liveUnlock = null;
      }
      if (this.handleLiveCanPlay) {
        const video = this.$refs.liveVideo;
        if (video) video.removeEventListener('canplay', this.handleLiveCanPlay);
        this.handleLiveCanPlay = null;
      }
      if (this.liveFlvPlayer) {
        try {
          this.liveFlvPlayer.detachMediaElement();
          this.liveFlvPlayer.destroy();
        } catch (e) {
          // 播放器可能尚未初始化完成，忽略销毁异常
        }
        this.liveFlvPlayer = null;
      }
    },
    onLiveVideoPause() {
      // 切换地址销毁播放器过程中触发的 pause 不变更状态；播放结束/中断时隐藏小窗
      if (this.livePlayState === 'playing') {
        this.livePlayState = 'paused';
      }
    },
    gioEvent(adPosition_var, courseName_var, trackMeta = {}) {
      console.log({
        adPosition_var,
        courseName_var,
        adId_var: trackMeta.adId || this.bookMallAdId || '',
        adName_var: trackMeta.adName || this.bookMallAdName || '',
        platform_var: gioPlatform(),
      });
      gio('track', 'H5adClick_event', {
        adPosition_var,
        courseName_var,
        adId_var: trackMeta.adId || this.bookMallAdId || '',
        adName_var: trackMeta.adName || this.bookMallAdName || '',
        platform_var: gioPlatform(),
      });
    },
    openFilterModal() {
      this.showFilterModal = true;
    },
    closeFilterModal() {
      this.showFilterModal = false;
    },
    onFilterConfirm(payload) {
      this.filterState = {
        examTypeIdList: [...(payload.examTypeIdList || [])],
        subjectIdList: [...(payload.subjectIdList || [])],
        bookTypeIdList: [...(payload.bookTypeIdList || [])],
      };
      this.closeFilterModal();
      this.resetBookMallPagination();
      this.getBookMall();
    },
    hotSaleCover(item) {
      const bookCover = item.productBookInfoVO?.bookCover;
      if (bookCover) return bookCover;
      return item.coverMobile || '';
    },
    hotSaleOriginPrice(item) {
      if (item.promotionLabel && item.originalPrice != null) return item.originalPrice;
      return '';
    },
    goHotSaleDetail(item) {
      this.gioEvent('商城热卖推荐', '', {
        adId: this.hotSaleAdId,
        adName: this.hotSaleAdName,
      });
      this.openCourse(item);
    },
    openCourse(item) {
      sessionStorage.setItem('back', true);
      if (item.setType === 1) {
        this.$router.push({
          path: '/combinationCourse',
          query: { combinationId: item.packageId },
        });
        return;
      }
      this.$router.push({
        path: '/courseDetail',
        query: { courseId: item.productId },
      });
    },
    async getHotSaleList() {
      const { code, data } = await reqMajorAd(BOOK_MALL_HOT_SALE_RECOMMEND_ID);
      if (code !== 0 || !data?.length) {
        this.hotSaleAdId = '';
        this.hotSaleAdName = '';
        return;
      }
      this.hotSaleAdId = data[0]?.id != null ? String(data[0].id) : '';
      this.hotSaleAdName = data[0]?.mainTitle != null ? String(data[0].mainTitle) : '';
      const { recommendContentVOList } = data[0];
      this.getMajorList(recommendContentVOList, 'hotSaleList');
    },
    // 进入图书详情
    goBookDetail(item) {
      this.gioEvent('商城课程列表', item.name);
      this.openCourse(item);
    },
    resetBookMallPagination() {
      this.bookMallPageNum = 1;
      this.hasMoreBookMall = true;
      this.bookList = [];
      this.bookMallListLoaded = false;
    },
    async getBookMall() {
      if (this.bookMallLoading) return;
      if (this.bookMallPageNum > 1 && !this.hasMoreBookMall) return;
      const { examTypeIdList, subjectIdList, bookTypeIdList } = this.filterState;
      const parmas = {
        baseBusinessLine: 1,
        homeRecommendId: BOOK_MALL_HOME_RECOMMEND_ID,
        examTypeIdList,
        subjectIdList,
        bookTypeIdList,
        pageNum: this.bookMallPageNum,
        pageSize: this.bookMallPageSize,
      };
      this.bookMallLoading = true;
      this.bookMallLoadingMore = this.bookMallPageNum > 1;
      try {
        const { code, data } = await reqBookMallList(parmas);
        if (code === 0) {
          const { recommendContentPageVO, id, mainTitle } = data || {};
          const list = recommendContentPageVO?.data || [];
          this.bookMallAdId = id != null ? String(id) : '';
          this.bookMallAdName = mainTitle != null ? String(mainTitle) : '';
          const pageNum = recommendContentPageVO?.pageNum || this.bookMallPageNum;
          const pages = recommendContentPageVO?.pages || 0;
          this.hasMoreBookMall = pageNum < pages;
          if (!list.length) {
            if (this.bookMallPageNum === 1) {
              this.bookList = [];
              this.bookMallListLoaded = true;
            }
            return;
          }
          this.getMajorList(list, 'bookList', this.bookMallPageNum > 1);
        } else {
          this.bookMallAdId = '';
          this.bookMallAdName = '';
          if (this.bookMallPageNum === 1) {
            this.bookList = [];
          }
          this.bookMallListLoaded = true;
        }
      } finally {
        this.bookMallLoading = false;
        this.bookMallLoadingMore = false;
      }
    },
    loadMoreBookMall() {
      if (this.bookMallLoading || !this.hasMoreBookMall) return;
      this.bookMallPageNum += 1;
      this.getBookMall();
    },
    handlePageScroll() {
      if (this.bookMallLoading || !this.hasMoreBookMall) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const clientHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight || clientHeight;
      if (scrollTop + clientHeight >= scrollHeight - 80) {
        this.loadMoreBookMall();
      }
    },
    getMajorList(recommendContentVOList, listKey = 'bookList', isAppend = false) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach((child) => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProductsNew(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};
      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = resetProductData(res?.data || [], 2);
        const resPackage = resetCoursePackage(res1?.data || []);
        const allCourse = [];
        recommendContentVOList.forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = child.recommendType === 0 ? course.productId : course.packageId;
            return id === child.productId;
          });
          // eslint-disable-next-line no-unused-expressions
          findRes && allCourse.push(findRes);
        });
        this[listKey] = isAppend ? [...this[listKey], ...allCourse] : allCourse;
        if (listKey === 'bookList') {
          this.bookMallListLoaded = true;
        }
      });
    },
  },
  mounted() {
    // 微信 webview：bridge ready 后部分版本允许无手势播放，须在页面加载期注册（事件只触发一次，注册晚了就收不到）
    this.setupWeixinBridgeUnlock();
    this.getBookMall();
    this.getHotSaleList();
    this.getFunctionModulesAd();
    this.getBookMallTopAd();
    this.initLivePlayer();
    window.addEventListener('scroll', this.handlePageScroll, { passive: true });
    localStorage.setItem('miniBeforePageName', 17);
    document.title = '图书商城';
  },
  beforeDestroy() {
    const bridge = window['iqhApp2jsBridge.triggerSC'];
    if (bridge && bridge.getLogin === this.getLogin) {
      delete bridge.getLogin;
    }
    window.removeEventListener('scroll', this.handlePageScroll);
    this.clearLiveEndTimer();
    this.destroyLivePlayer();
  },
};
</script>

<style lang="scss" scoped>
.book-mall-page {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 750px;
  max-width: 100%;
  margin: 0 auto;
  padding: 22px 36px 0 36px;
  overflow: hidden;
  background: #f7f8fc;

  .search-wrapper {
    .search-input-box {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      padding: 18px 442px 18px 24px;
      background-color: rgba(255, 255, 255, 1);
      border-radius: 40px;

      .search-icon {
        width: 22px;
        height: 22px;
        margin: 9px 0 7px 0;
      }

      .search-placeholder {
        padding-left: 10px;
        color: rgba(153, 153, 153, 1);
        font-size: 25px;
        line-height: 36px;
        white-space: nowrap;
      }
    }
  }

  /* 悬浮广告气泡：样式仿 arkHome/chat.vue 的 yuanqiu（fixed 右侧悬浮 + 可拖拽 + 可关闭），功能仍为广告位点击跳转 */
  .book-mall-top-ad {
    position: fixed;
    right: 15px;
    bottom: 150px;
    z-index: 999;
    width: 170px;
    height: 170px;
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);

    >img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 14px;
    }

    .book-mall-top-ad-close {
      position: absolute;
      top: -20px;
      right: -5px;

      img {
        width: 40px;
        height: 40px;
      }
    }
  }

  .book-mall-top-ad-animate {
    transition-duration: 0.4s;
  }

  .book-mall-live-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: 678px;
    margin: 22px auto 0;
    padding: 16px 29px;
    background: #fff;
    border-radius: 18px;

    .book-mall-live-info {
      display: flex;
      align-items: center;
      min-width: 0;
    }

    .book-mall-live-avatar {
      display: flex;
      flex: 0 0 78px;
      align-items: center;
      justify-content: center;
      width: 78px;
      height: 78px;
      border-radius: 50%;

      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
      }
    }

    .book-mall-live-content {
      min-width: 0;
      margin-left: 14px;
    }

    .book-mall-live-title {
      max-width: 430px;
      overflow: hidden;
      color: #333;
      font-weight: 500;
      font-size: 25px;
      line-height: 36px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .book-mall-live-summary {
      display: flex;
      align-items: center;
      margin-top: 7px;
    }

    .book-mall-live-status {
      width: 87px;
      height: 31px;
      padding: 0 11px;
      color: #fff;
      font-weight: 500;
      font-size: 22px;
      line-height: 31px;
      white-space: nowrap;
      text-align: center;
      // background: url('https://lanhu-oss-2537-2.lanhuapp.com/SketchPng886b12ade8fb6e6d0b3af7ebd63300d258cca93f1c53b703c82e3d891fe0e735') center/100% 100% no-repeat;
    }

    .book-mall-live-description {
      margin-left: 7px;
      overflow: hidden;
      color: #999;
      font-size: 20px;
      line-height: 29px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .book-mall-live-play {
      flex: 0 0 47px;
      width: 47px;
      height: 47px;
      margin-left: 14px;
    }
  }

  .book-mall-banner {
    width: 678px;
    margin-top: 22px;
    // height: 205px;
  }

  .function-modules {
    display: flex;
    justify-content: space-between;
    margin: 22px 0 0 0;

    /* 无直播且无广告位时整块收起，不留空隙 */
    &.function-modules-empty {
      margin-top: 0;
    }

    .function-modules-left {
      position: relative;
      flex: 0 0 331px;
      width: 331px;
      height: 337px;
      overflow: hidden;
      background: #000;
      border-radius: 18px;
      overflow: hidden;

      .function-modules-left-shadow {
        position: absolute;
        width: 331px;
        height: 337px;
        top: 0;
        left: 0;
        z-index: 3;
      }

      /* 微信 iOS 拦截自动播放期间的播放提示，仅提示不接管点击（点击仍进直播间） */
      .live-video-play-hint {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 4;
        width: 88px;
        height: 88px;
        transform: translate(-50%, -50%);

        img {
          width: 100%;
          height: 100%;
        }
      }

      .function-modules-title-box {
        position: absolute;
        z-index: 1;
        left: 0px;
        top: 0px;
        padding-top: 24px;
        padding-left: 14px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;

        width: 332px;
        height: 116px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.75) 0%, rgba(43, 50, 99, 0) 100%);
        border-radius: 18px 18px 0px 0px;

        img {
          display: block;
          height: 29px;
          width: 29px;
        }

        div {
          margin-left: 7px;
          height: 29px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 25px;
          color: #FFFFFF;
          line-height: 29px;
        }

      }

      .function-modules-title-sub {
        position: absolute;
        z-index: 1;
        left: 0px;
        padding-left: 14px;
        bottom: 0px;
        padding-bottom: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #FFFFFF;
        line-height: 31px;

        width: 332px;
        height: 116px;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.75) 0%, rgba(43, 50, 99, 0) 100%);
        border-radius: 0px 0px 18px 18px;
        display: flex;
        align-items: flex-end;
        justify-content: flex-start;

        div {
          height: 31px;
          line-height: 31px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 22px;
          color: #FFFFFF;
        }
      }

      .live-video {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .function-modules-right {
      min-width: 0;

      .new-user-welfare {
        position: relative;
        width: 332px;
        height: 161px;
      }

      .seckill-course {
        position: relative;
        width: 332px;
        height: 161px;
        margin-top: 14px;
      }
    }

    /* 无直播：小窗隐藏，两个广告位横排一行（同无直播窗版本布局） */
    &.function-modules-no-live {
      .function-modules-right {
        display: flex;
        flex: 1;
        justify-content: space-between;
        width: 100%;

        .seckill-course {
          margin-top: 0;
        }
      }
    }
  }

  .hot-sale-section {
    margin: 22px 0 0 0;
    padding: 22px 29px 33px 29px;
    background: #fff;
    border: 2px solid #fff;
    border-radius: 14px;

    .hot-sale-header {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 22px;

      .section-title {
        margin-right: 9px;
        color: rgba(17, 17, 17, 1);
        font-weight: 500;
        font-size: 29px;
        line-height: 40px;
        white-space: nowrap;
      }

      .hot-tags {
        position: relative;
        display: flex;
        flex-direction: row;
        margin: 2px 0 5px 0;
        // background: url(https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/boolMall/book_hot_icon.png) 100% no-repeat;
        // background-size: 100% 100%;

        .hot-tag-item {
          display: flex;
          flex-direction: row;
          align-items: center;
          width: 74px;
          height: 31px;

          .hot-icon {
            width: 96px;
            height: 34px;
          }

          .hot-text {
            margin-top: 9px;
            color: rgba(255, 87, 0, 1);
            font-size: 18px;
            line-height: 20px;
            white-space: nowrap;
          }
        }
      }
    }

    .hot-book-list {
      display: flex;
      flex-direction: row;
      gap: 14px;
      width: 100%;
      /* 移动端全屏宽度 */
      margin: 22px 0 0 0;

      /* ===== 横向滑动核心代码 ===== */
      overflow-x: auto;
      /* 开启横向滚动 */
      overflow-y: hidden;
      /* 禁止纵向滚动 */
      white-space: nowrap;
      /* 禁止换行 */
      scrollbar-width: none;
      /* 火狐隐藏滚动条 */
    }

    /* 隐藏滚动条（Chrome/Safari） */
    .hot-book-list::-webkit-scrollbar {
      display: none;
    }

    .book-item {
      /* 固定宽度，不让 flex 压缩 */
      flex-shrink: 0;
      width: 188px;
    }

    .book-cover {
      position: relative;
      margin-bottom: 9px;

      img {
        width: 188px;
        height: 250px;
        object-fit: cover;
        /* 图片不变形 */
        border-radius: 14px;
      }

      .origin-text {
        position: absolute;
        bottom: 7px;
        left: 7px;
        display: inline-block;
        width: 82px;
        color: #fff;
        font-weight: 500;
        font-size: 18px;
        line-height: 29px;
        text-align: center;
        background: rgba(31, 32, 46, 0.6);
        border-radius: 5px;
      }
    }

    .book-price {
      position: relative;
      width: 188px;
      font-size: 28px;
      background: #ffe7dd;
      border-radius: 7px;

      .courseType {
        display: inline-block;
        padding-left: 7px;
        color: #ff3b00;
        font-weight: 400;
        font-size: 18px;
        line-height: 29px;
      }

      .showPic {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 125px;
        height: 33px;
        color: hsl(0, 0%, 100%);
        font-weight: 500;
        font-size: 22px;
        line-height: 25px;
        line-height: 33px;
        text-align: center;
        background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/boolMall/price-bg.png?v=2');
        background-size: 100%;
      }
    }

    .bookName {
      display: -webkit-box;
      margin-top: 22px;
      overflow: hidden;
      color: #333;
      font-weight: 500;
      font-size: 25px;
      line-height: 33px;
      white-space: normal;
      text-overflow: ellipsis;
      word-break: break-word;
      -webkit-line-clamp: 2;
      /* 控制行数：2行 */
      -webkit-box-orient: vertical;
    }
  }

  .category-filter {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 678px;
    margin: 22px 36px 0 5px;

    .filter-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 217px;
      padding: 22px 22px 22px 22px;
      background-color: rgba(255, 255, 255, 1);
      border-radius: 14px;

      .filter-text {
        color: rgba(153, 153, 153, 1);
        font-size: 25px;
        line-height: 36px;
        white-space: nowrap;
      }

      .filter-text-active {
        color: #ff7f41;
      }

      .filter-arrow {
        width: 40px;
        height: 40px;
      }
    }
  }

  .book-card-list {
    display: flex;
    flex-direction: column;
    gap: 22px;
    margin: 22px 0 0 0;

    .book-card-list-end {
      margin: 0 0 36px;
      padding: 0 36px;
      color: rgba(153, 153, 153, 1);
      font-size: 25px;
      line-height: 36px;
      text-align: center;
    }
  }

  ::v-deep .emptyIndent {
    height: fit-content !important;
    padding: 50px 0;

    .product {
      display: none;
    }
  }
}
</style>
